import type { MouseEvent } from 'react';

export const isFromButton = (e: MouseEvent): boolean => (e.target as Element).closest('button') !== null;
